<template>
    <div class="checkbox">
        <div class="togglebutton">
            <toggle-button
                v-model="selected"
                @input="onChange"
                :sync="true"
                :color="color ? color : { checked: '#07da70', unchecked: '#e85d75' }"
                :disabled="iniDisabled"
            />
            <label class="control-label m-b-0">{{ label }}</label>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import ToggleButton from 'vue-js-toggle-button';
Vue.use(ToggleButton);

export default {
    name: 'FormToggleButton',
    props: ['label', 'iniDisabled', 'value', 'color'],
    data() {
        return {
            selected: null,
        };
    },
    watch: {
        value() {
            this.handleValue();
        },
    },
    created() {
        this.handleValue();
    },
    methods: {
        handleValue() {
            this.selected = this.value;
        },
        onChange(value) {
            this.selected = value;
            this.$emit('input', value);
        },
    },
};
</script>
